// Global
import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { useTheme } from 'lib/context/ThemeContext';
import { useBVScript } from 'lib/utils/use-bv-script';
import { useEffect, useState } from 'react';
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';

// Components
import Component from 'src/helpers/Component/Component';
import Headline from 'src/helpers/Headline/Headline';
import SvgIcon from 'src/helpers/SvgIcon/SvgIcon';
import { BazaarvoiceReviewsTheme } from './BazaarvoiceReviews.theme';

export type BazaarvoiceReviewsProps =
  Feature.EnterpriseWeb.AndersenWindows.Components.General.BazaarvoiceReviews.BazaarvoiceReviews;
const BazaarvoiceReviews = (props: BazaarvoiceReviewsProps) => {
  const { themeName, themeData } = useTheme(BazaarvoiceReviewsTheme);

  // Add the bazaarvoice script
  useBVScript({ environment: process.env.NEXT_PUBLIC_EW_ENVIRONMENT, theme: themeName });

  function isEmpty(value: string) {
    return value == null || (typeof value === 'string' && value.trim().length === 0);
  }

  const productItem = props?.fields?.productItem;
  const bazaarvoiceProductIdOverride = props?.fields?.bazaarvoiceProductIdOverride?.value;
  let bazaarvoiceProductId = productItem?.fields?.bazaarvoiceProductId?.value;

  if (!isEmpty(bazaarvoiceProductIdOverride)) {
    bazaarvoiceProductId = bazaarvoiceProductIdOverride;
  }

  const componentId = 'bazaarvoiceReview-' + bazaarvoiceProductId;
  const [isOpen, setOpen] = useState(false);

  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  return (
    <Component variant="lg" dataComponent="general/bazaarvoicereviews" {...props}>
      <Headline classes={themeData.classes.headline} {...props} />
      <div className={themeData.classes.wrapperClass}>
        <a
          className={themeData.classes.accordionToggleContainer}
          data-anchor-name={'#' + componentId}
        >
          <h3 className={themeData.classes.accordionHeadline} onClick={() => setOpen(!isOpen)}>
            <div className={themeData.classes.readMore}>Read Reviews</div>
            <div
              className={themeData.classes.accordionRatingContainer}
              data-bv-show="rating_summary"
              data-bv-product-id={bazaarvoiceProductId}
            ></div>
            <div className={themeData.classes.accordionToggleIndicator}>
              <SvgIcon
                icon={isOpen ? 'minus' : 'plus'}
                size="18"
                className={themeData.classes.iconClass}
              />
            </div>
          </h3>
        </a>
        <div
          className={`content-container ${
            isOpen ? themeData.classes.contentOpen : themeData.classes.contentClosed
          }`}
          id={componentId}
        >
          <div className="content">
            <div data-bv-show="reviews" data-bv-product-id={bazaarvoiceProductId}></div>
          </div>
        </div>
      </div>
    </Component>
  );
};

export default withDatasourceCheck()<BazaarvoiceReviewsProps>(BazaarvoiceReviews);
